import { render, staticRenderFns } from "./InputsPage.vue?vue&type=template&id=0315e7c5&scoped=true&"
import script from "./InputsPage.vue?vue&type=script&lang=js&"
export * from "./InputsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315e7c5",
  null
  
)

export default component.exports